import React, { useState, useRef, useEffect } from 'react'
import { toast } from 'sonner'

const API = process.env.REACT_APP_BACKEND_URL

export default function InlineSelectCell({ sinistre, field, options, onUpdated, placeholder = '--' }) {
  const [open, setOpen] = useState(false)
  const [saving, setSaving] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    function handleClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false)
    }
    if (open) document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [open])

  const current = sinistre[field]
  const currentOpt = options.find(o => o.value === current)

  async function handleSelect(value) {
    if (value === current) { setOpen(false); return }
    setSaving(true)
    try {
      const payload = {}
      payload[field] = value
      const res = await fetch(`${API}/api/sinistres/${sinistre.id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
      if (res.ok && onUpdated) onUpdated()
      if (!res.ok) { const d = await res.json().catch(() => ({})); toast.error(typeof d.detail === 'string' ? d.detail : (d.detail?.message || 'Erreur de mise à jour')) }
    } finally {
      setSaving(false)
      setOpen(false)
    }
  }

  return (
    <div className="relative" ref={ref} onClick={e => e.stopPropagation()}>
      <button
        onClick={() => setOpen(!open)}
        disabled={saving}
        className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium transition-colors cursor-pointer hover:ring-2 hover:ring-indigo-200 ${
          currentOpt ? currentOpt.color : 'bg-slate-50 text-slate-400'
        }`}
        data-testid={`inline-select-${field}`}
      >
        {currentOpt?.dot && <span className={`w-1.5 h-1.5 rounded-full ${currentOpt.dot}`} />}
        {saving ? '...' : (currentOpt?.label || placeholder)}
      </button>

      {open && (
        <div className="absolute z-50 left-0 top-full mt-1 bg-white rounded-lg shadow-xl border border-slate-200 py-1 min-w-[120px]"
             data-testid={`inline-select-${field}-dropdown`}>
          {options.map(o => (
            <button
              key={o.value ?? 'null'}
              onClick={() => handleSelect(o.value)}
              className={`w-full text-left px-3 py-1.5 text-xs hover:bg-slate-50 flex items-center gap-2 ${
                current === o.value ? 'font-bold bg-indigo-50' : ''
              }`}
            >
              {o.dot && <span className={`w-2 h-2 rounded-full ${o.dot}`} />}
              {o.label}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
